<div class="widthClass">
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">&nbsp;Add Court Date</span>
      <button (click)="dialogRef.close(false)" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value" [bufferValue]="bufferValue">
  </mat-progress-bar>

  <div style="margin:30px;">
      <div>
        <form name="addForm" [formGroup]="addForm" class="alert-form w-100-p" fxLayout="column" fxFlex>
          <mat-form-field appearance="fill">
            <mat-label>Select a date</mat-label>
            <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate" formControlName="dateVal" readonly>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </form>
      </div>

    <div class="actionButtons">
      <button [class.loading]="loading" mat-raised-button color="accent" aria-label="Add" (click)="addCourtDate()"
        [disabled]="addForm.invalid || loading" style="float:right;">
        <div class="spinner"></div>
        <span class="label" style="text-transform: uppercase;">Add</span>
      </button>
    </div>
    <br>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/court-dates/add/add.component.html